module.exports = __webpack_public_path__ + "static/encounter-scheduling-2-5dd0fa14255c3f893ad8284b52f88b60.png";